var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _vm.item.latestActionDate
      ? _c("td", [
          _c("span", [
            _vm._v(_vm._s(_vm._f("formatDate")(_vm.item.latestActionDate)))
          ])
        ])
      : _c("td", { staticClass: "centered" }, [_c("span", [_vm._v("-")])]),
    _vm._v(" "),
    _vm.item.aidTargetNumber
      ? _c("td", [_c("span", [_vm._v(_vm._s(_vm.item.aidTargetNumber))])])
      : _c("td", { staticClass: "centered" }, [_c("span", [_vm._v("-")])]),
    _vm._v(" "),
    _vm.item.year
      ? _c("td", [_c("span", [_vm._v(_vm._s(_vm.item.year))])])
      : _c("td", { staticClass: "centered" }, [_c("span", [_vm._v("-")])]),
    _vm._v(" "),
    _vm.item.displayTaskType
      ? _c("td", [
          _c(
            "span",
            [
              _vm._v(
                "\n      " + _vm._s(_vm.item.displayTaskType) + "\n      "
              ),
              _vm.item.isOnlineViewAvailable && !_vm.item.onlineViewIndefinitely
                ? _c("tooltip-icon", {
                    attrs: { content: _vm.item.tooltipContent }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      : _c("td", { staticClass: "centered" }, [_c("span", [_vm._v("-")])]),
    _vm._v(" "),
    _vm.item.displayState
      ? _c("td", [_c("span", [_vm._v(_vm._s(_vm.item.displayState))])])
      : _c("td", { staticClass: "centered" }, [_c("span", [_vm._v("-")])]),
    _vm._v(" "),
    _c("td", { staticClass: "centered" }, [
      _c("span", [
        _vm.item.showArchiveButton &&
        _vm.item.isArchived &&
        !(_vm.procurationOnly && !_vm.hasProcuration)
          ? _c("span", [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.sendArchiveReportRequestDebounced }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.item.archiveButtonLabel) +
                      "\n        "
                  )
                ]
              )
            ])
          : _vm.item.showArchiveButton &&
            (!_vm.item.isArchived ||
              (_vm.procurationOnly && !_vm.hasProcuration))
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.top.center",
                    value: { content: _vm.archiveButtonTooltip },
                    expression: "{ content: archiveButtonTooltip }",
                    modifiers: { top: true, center: true }
                  }
                ],
                attrs: { tabindex: "0" }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: {
                      type: "button",
                      disabled: "",
                      "aria-disabled": "true"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.item.archiveButtonLabel) + " "
                    ),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(" " + _vm._s(_vm.archiveButtonTooltip))
                    ])
                  ]
                )
              ]
            )
          : _vm.item.isOnlineViewAvailable
          ? _c(
              "span",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      tag: "button",
                      to: {
                        name: _vm.item.routeValue,
                        params: { id: _vm.item.recordId }
                      },
                      "aria-label": _vm.$t("Btn_Open")
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("Btn_Open")) + "\n        "
                    )
                  ]
                )
              ],
              1
            )
          : _c("span", [_vm._v("-")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }